import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const DiscoveryStatusContext = createContext({ enabled: false, loading: true });

export const DiscoveryStatusProvider = ({ children }) => {
  const [status, setStatus] = useState({ enabled: false, loading: true });

  useEffect(() => {
    let active = true;
    const refresh = () => {
      axios.get('/api/discovery/status')
        .then(({ data }) => {
          if (active) setStatus({ enabled: data?.enabled === true, loading: false });
        })
        .catch(() => {
          if (active) setStatus({ enabled: false, loading: false });
        });
    };
    refresh();
    window.addEventListener('focus', refresh);
    return () => {
      active = false;
      window.removeEventListener('focus', refresh);
    };
  }, []);

  return <DiscoveryStatusContext.Provider value={status}>{children}</DiscoveryStatusContext.Provider>;
};

export const useDiscoveryStatus = () => useContext(DiscoveryStatusContext);
